export default __webpack_public_path__ + "static/media/video_call.c135ee53.png";